const testimonials = [
  {
    name: "Travis B.",
    location: "Upper Grand Lagoon, FL",
    rating: 5,
    text: "I live right off Thomas Drive and needed a passport renewal for a last-minute work trip to Costa Rica. Fast Passport Center made it so easy — I shipped my docs from the UPS Store on Front Beach Road and had my passport back in 5 days. Couldn't believe how smooth it was.",
    service: "Passport Renewal",
  },
  {
    name: "Amanda K.",
    location: "Panama City Beach, FL",
    rating: 5,
    text: "My daughter's passport expired two weeks before our family cruise out of Port Canaveral. We're in Upper Grand Lagoon and panicked. FPC walked us through the child passport process, told us exactly which clerk to visit in Panama City, and got everything done in time. Lifesavers.",
    service: "Child Passport",
  },
  {
    name: "James R.",
    location: "Lynn Haven, FL",
    rating: 5,
    text: "Tyndall AFB transferred me overseas on short notice and I realized my passport had less than 6 months validity. FPC got me a same-day emergency turnaround. The team was professional, kept me updated, and handled everything while I was prepping for the move. Outstanding service.",
    service: "Emergency Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function UpperGrandLagoonTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Upper Grand Lagoon Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Upper Grand Lagoon, Panama City Beach, and the Emerald Coast who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}